import { Subject } from '@state-containers/core';

interface CalendarStateInterface {
  focusedTimeBlockId: string | null;
}

export const CalendarState = () => {
  const state = new Subject<CalendarStateInterface>({
    focusedTimeBlockId: null,
  });

  const actions = {
    focusTimeBlock: (blockId: string) => {
      console.log('focusing block', blockId);
      state.value = {
        ...state.value,
        focusedTimeBlockId: blockId,
      };
    },
    unfocusTimeBlock: () => {
      state.value = {
        ...state.value,
        focusedTimeBlockId: null,
      };
    },
  };

  return { state, actions };
};
